<template>
    <div class="form_group form_group_document_brand">
        <display-message :option="message_option"></display-message>
<!--        <div class="form_row" v-for="field_name in available_fields" v-if="current_item_field[field_name].field_type === 'address'">-->
<!--            <label :for="module_name+'_'+field_name" v-html="field_label(field_name)"></label>-->
<!--            <a title="Edit" class="glyphicon glyphicon-pencil" href="javascript:void(0);" v-show="!current_chosen[field_name]" @click="current_chosen[field_name] = true"></a>-->
<!--            <div class="form_static_value" v-show="!current_chosen[field_name]" v-html="formatted_field_value(field_name)"></div>-->
<!--            <update-address v-show="current_chosen[field_name]" :option="{item_list:item_list,item_map:item_map,address_name:field_name}" v-on:update:new_address="subform_submit"></update-address>-->
<!--        </div>-->
<!--        <input disabled type="hidden" :id="module_name+'_'+field_name" :name="field_name" :value="cache_data[field_name]" v-else-if="current_item_field[field_name].field_type === 'hidden'">-->
<!--        <div class="form_row" :class="'form_row_'+current_item_field[field_name].field_type+'_container'" v-else-if="current_item_field[field_name]">-->
        <template v-for="field_name in available_fields" :key="field_name">
            <div class="form_row" :class="'form_row_'+current_item_field[field_name].field_type+'_container'" v-if="current_item_field[field_name] && current_item_field[field_name].field_type === 'address'">
                <label :for="module_name+'_'+field_name" v-html="field_label(field_name)"></label>
                <a title="Edit" class="glyphicon glyphicon-pencil" href="javascript:void(0);" v-show="!current_chosen[field_name]" @click="current_chosen[field_name] = true"></a>
                <div class="form_static_value" v-show="!current_chosen[field_name]" v-html="formatted_field_value(field_name)"></div>
                <update-address v-show="current_chosen[field_name]" v-on:update:new_address="subform_submit"></update-address>
            </div>
            <div class="form_row" :class="'form_row_'+current_item_field[field_name].field_type+'_container'" v-else-if="current_item_field[field_name] && current_item_field[field_name].field_type === 'image'">
                <label :for="module_name+'_'+field_name" v-html="field_label(field_name)"></label>
                <a title="Edit" class="glyphicon glyphicon-pencil" href="javascript:void(0);" v-show="!current_chosen[field_name]" @click="current_chosen[field_name] = true"></a>
                <a title="Delete" class="glyphicon glyphicon-trash" href="javascript:void(0);" v-show="!current_chosen[field_name] && cache_data[field_name]" @click="cache_data[field_name] = ''"></a>
                <div class="form_static_value" v-show="!current_chosen[field_name]">
                    <img v-if="cache_data[field_name]" :src="cache_data[field_name]">
                    <img v-else-if="cache_data['name']" :src="'/assets/image/document/'+cache_data['name']+'/'+current_item_field[field_name].image_name+'.jpg'">
                </div>
                <update-image v-show="current_chosen[field_name]" :option="current_item_field[field_name].editor_option" @submit="subform_submit"></update-image>
            </div>
            <div class="form_row" :class="'form_row_'+current_item_field[field_name].field_type+'_container'" v-else-if="current_item_field[field_name]">
                <label :for="module_name+'_'+field_name" v-html="field_label(field_name)" v-show="show_label(field_name)"></label>
                <textarea v-if="current_item_field[field_name].field_type === 'textarea'" :id="module_name+'_'+field_name" :name="field_name" v-model="cache_data[field_name]" :placeholder="field_label(field_name, 'placeholder')" @change="field_change(field_name)"></textarea>
                <div v-else-if="current_item_field[field_name].field_type === 'select'" class="select_container">
                    <select :id="module_name+'_'+field_name" :name="field_name" v-model="cache_data[field_name]" :placeholder="field_label(field_name, 'placeholder')" @change="field_change(field_name)">
                        <option :value="typeof current_item_field[field_name].empty_value !== 'undefined'?current_item_field[field_name].empty_value:''" v-show="cache_data[field_name]===''||mandatory_fields.indexOf(field_name) === -1" v-html="cache_data[field_name]===''?field_label(field_name, 'select_default'):'-- Unselected --'"></option>
                        <option :value="field_available_option.id" v-for="field_available_option in field_available_options[field_name]">{{ field_available_option.name }}</option>
                    </select>
                </div>

                <!--                    <div v-else-if="current_item_field[field_name].field_type === 'subform_multi'">-->
                <!--                        Hello World-->
                <!--                    </div>-->
                <input v-else :type="current_item_field[field_name].field_type" :id="module_name+'_'+field_name" :name="field_name" v-model="cache_data[field_name]" :placeholder="field_label(field_name, 'placeholder')" @change="field_change(field_name)">
            </div>
        </template>
<!--        <update-image v-show="current_chosen['main_image']" :option="{target_image:{width:400,height:'auto',ratio:'auto'},field_name:'main_image'}" @submit="subform_submit"></update-image>-->
<!--        <update-image :option="{target_image:{width:'auto',height:40,ratio:'auto'},field_name:'footer_image'}" @submit="subform_submit"></update-image>-->

        <div class="form_row form_row_controller_container" v-show="!subform_chosen">
            <input type="button" class="btn btn-primary" value="Save" @click="save()">
            <input type="button" class="btn btn-secondary-inverse" value="Cancel" @click="cancel()">
        </div>
    </div>    
</template>

<script>
    export default {
        name: "UpdateDocumentBrand",
        props: ['option','current_id'],
        data() {
            let data_set = {
                module_name: 'document_brand',
                autocomplete: null,
                current_item_field:{},
                available_fields:[],            // function place holder, override from root data init
                mandatory_fields:[],
                cache_data: {},
                cache_data_label: {
                    display_name:'Company Name',
                    website:'Website',
                    email:'Email',
                    phone:'Phone',

                    address_id:'Address',

                    name:'Image Path Name',

                    main_image: 'Cover Page Logo (400 x 150 pixel)',

                    footer_image: 'Footer Logo (200 x 40 pixel)',
                    // company_id:'Company',
                },
                current_chosen:{},          // Indicate current chosen value for subform_multi and other similar field_type
                item_list: {
                    address:[],
                    document_brand:[]
                },
                item_map: {
                    address: {},
                    document_brand: {}
                },
                message_option: {
                    message: '',
                    message_type: ''
                },
            };
            let current_object = this;
            data_set.cache_data = current_object.reset_cache_data({init:true,module_name:data_set.module_name});
            Object.keys(data_set.cache_data).forEach(function (field_name) {
                data_set.current_chosen[field_name] = '';
            });
            Object.keys(current_object.option).forEach(function (option_key) {
                data_set[option_key] = current_object.option[option_key];
            });

            // current_object.get_available_fields(data_set);
            return data_set;
        },
        computed: {
            subform_chosen: function () {
                let current_object = this;
                let chosen_count = 0;
                Object.keys(current_object.current_chosen).forEach(function (field_name) {
                    if (current_object.current_chosen[field_name]) {
                        chosen_count++;
                    }
                });
                return chosen_count;
            },
        },
        mounted() {
            let current_object = this;
            let root = current_object.$root;
            let parent = current_object.$parent;
            if (root.item_field && root.item_field[current_object.module_name]) {
                current_object.current_item_field = current_object.$root.item_field[current_object.module_name];
                current_object.get_available_fields();
            }
            if (parent.item_list) {
                current_object.item_list = parent.item_list;
            }
            if (parent.item_map) {
                current_object.item_map = parent.item_map;
            }
        },
        methods: {
            reset_cache_data: function(option) {
                if (typeof option === 'undefined') {
                    option = {};
                }

                let current_object = this;

                let cache_data = {
                    display_name:'',
                    website:'',
                    email:'',
                    phone:'',

                    name:'',

                    address_id:'',

                    main_image:'',

                    footer_image:''
                };
                if (!option.init) {
                    current_object.cache_data = Object.assign(current_object.cache_data,cache_data);
                    cache_data = current_object.cache_data;
                }

                if (current_object.current_id) {
                    if (current_object.item_map['document_brand'] && current_object.item_map['document_brand'][current_object.current_id]) {
                        cache_data = Object.assign(cache_data, current_object.item_map['document_brand'][current_object.current_id]);
                    } else {
                        // Init with default
                        if (current_object.$root.item_map['document_brand'] && current_object.$root.item_map['document_brand'][current_object.current_id]) {
                            if (!current_object.item_map['document_brand']) {
                                current_object.item_map['document_brand'] = {};
                            }
                            current_object.item_map['document_brand'][current_object.current_id] = Object.assign({}, current_object.$root.item_map['document_brand'][current_object.current_id]);
                            cache_data = Object.assign(cache_data, current_object.$root.item_map['document_brand'][current_object.current_id]);
                        } else {
                            if (current_object.$root.item_map['company'][current_object.current_id]) {
                                cache_data = Object.assign(cache_data, {
                                    id: current_object.current_id,
                                    company_id: current_object.current_id,
                                    name: String(current_object.current_id),
                                    display_name: current_object.$root.item_map['company'][current_object.current_id].name,
                                    address_id: current_object.$root.item_map['company'][current_object.current_id].address_id
                                });
                            }
                        }
                    }


                }

                if (current_object.option) {
                    if (current_object.current_id && option.module_name) {
                        if (current_object.option.item_map[option.module_name][current_object.current_id]) {
                            cache_data = Object.assign(cache_data, current_object.option.item_map[option.module_name][current_object.current_id]);
                        }
                    }
                }

                return cache_data;

            },

            get_available_fields: function (data_set) {
                let current_object = this;
                let root = current_object.$root;
                if (typeof data_set === 'undefined') {
                    data_set = current_object;
                }
                data_set.available_fields.splice(0,data_set.available_fields.length);
                if (current_object.current_item_field) {
                    Object.keys(current_object.current_item_field).forEach(function (field_name) {
                        if (['fillable','image_data','reference_list'].indexOf(current_object.current_item_field[field_name].flag_field) >= 0 ) {
                            if (['display_name','website','email','phone','address_id','main_image','footer_image'].indexOf(field_name) >= 0) {
                                data_set.available_fields.push(field_name);
                            }
                        }
                    });
                }
            },

            remove_from_list: function (item, list) {
                let index = list.indexOf(item);
                if (index > -1) {
                    list.splice(index,1);
                }
            },

            formatted_field_value: function(field_name) {
                let current_object = this;
                let current_value = current_object.cache_data[field_name];
                if (current_object.current_item_field[field_name]) {
                    let current_field = current_object.current_item_field[field_name];
                    if (current_field.formatted_content && field_name !== 'address_id') {
                        if (typeof current_field.formatted_content === 'function') {
                            return current_field.formatted_content(current_value);
                        }
                        if (typeof current_field.formatted_content === 'object') {
                            return current_field.formatted_content[current_value];
                        }
                    } else {
                        if (current_object.item_map && current_field.ref_name && current_object.item_map[current_field.ref_name] !== current_field._ref) {
                            current_field._ref = current_object.item_map[current_field.ref_name];
                        }
                        if (current_field._ref) {
                            if (current_field._ref[current_value]) {
                                if (current_field._ref[current_value].formatted_name) {
                                    return current_field._ref[current_value].formatted_name;
                                }
                                if (current_field._ref[current_value].formatted_address) {
                                    return current_field._ref[current_value].formatted_address;
                                }
                                if (current_field._ref[current_value].name) {
                                    return current_field._ref[current_value].name;
                                }
                            } else {
                                return 'N/A';
                            }
                        }
                        if (current_field.field_available_options) {
                            console.log('allen debug current_field.field_available_options',current_field.field_available_options,current_value);
                            for (let i=0;i<current_field.field_available_options.length;i++) {
                                if (current_field.field_available_options[i].id === current_value) {
                                    return current_field.field_available_options[i].name;
                                }
                            }
                        }
                    }

                }
                return current_value;

            },

            show_label: function(field_name) {
                let current_object = this;
                if (typeof current_object.cache_data[field_name] === 'undefined' || typeof current_object.current_item_field[field_name] === 'undefined') {
                    console.log('show_label failed, field_name does not exist in cache_data and/or item_field',field_name,current_object.cache_data,current_object.item_field);
                    return false;
                }
                let result = 1;
                switch (current_object.current_item_field[field_name].field_type) {
                    case 'checkbox':
                    case 'date':
                    case 'radio':
                    case 'subform':
                    case 'subform_multi':
                        break;
                    default:
                        result = (current_object.cache_data[field_name] !== '');

                }
                console.log('show_label result',field_name,current_object.current_item_field[field_name].field_type,result);
                return result;
            },

            field_change: function() {

            },

            field_label: function(field_name,label_type) {
                let current_object = this;

                if (!field_name || !current_object.cache_data_label[field_name]) {
                    return '';
                }

                if (typeof label_type === 'undefined') {
                    label_type = 'label';
                }

                let result = current_object.cache_data_label[field_name];

                switch (label_type) {
                    case 'placeholder':
                        if (current_object.mandatory_fields.indexOf(field_name) === -1 && !/^_/.test(field_name)) {
                            result += ' (optional)';
                        }
                        break;
                    case 'select_default':
                        result = '-- '+result+' --';
                        break;
                    case 'label':
                    default:
                }
                return  result;
            },

            subform_submit: function (item_id, field_name, subform_action) {
                console.log('allen debug subform_submit',item_id,field_name);
                let current_object = this;

                current_object.current_chosen[field_name] = '';

                if (typeof subform_action === 'undefined') {
                    subform_action = 'submit';     // By default, action submit is called
                }

                if (subform_action === 'cancel') {
                    return true;
                }

                if (Array.isArray(current_object.cache_data[field_name])) {
                    let trust_party = current_object.item_map[current_object.module_name+'_party'][item_id];
                    console.log('allen debug update_attached_trust_party',item_id,field_name,trust_party,current_object.current_chosen,current_object);
                    if (!item_id) {
                        return false;
                    }

                    if (!trust_party) {
                        current_object.message_option.message = ['Invalide item_id: ',item_id];
                        current_object.message_option.message_type = 'error';
                        return false;
                    }

                    if (current_object.cache_data[field_name].indexOf(item_id) === -1) {
                        current_object.cache_data[field_name].push(item_id);
                    }
                } else {
                    current_object.cache_data[field_name] = item_id;
                }
            },

            save: function () {
                // TODO: if store_for_future checked, post stored data to server

                let current_object = this;
                let warning_message = [];
                let formatted_name = '';
                let post_data = {};

                current_object.available_fields.forEach(function (field_name) {
                    post_data[field_name] = current_object.cache_data[field_name];
                });

                current_object.message_option.message = '';

                if (post_data.email) {
                    if (!post_data.email.toLowerCase()
                        .match(
                            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        )) {
                        warning_message.push('Invalid Email Address.');
                    }
                }
                // General Validation, e.g. mandatory field empty, number format wrong...
                current_object.mandatory_fields.forEach(function (field_name) {
                    if (!post_data[field_name]) {
                        warning_message.push('Field "'+current_object.cache_data_label[field_name]+'" is required.');
                    }
                });


                if (warning_message.length > 0) {
                    current_object.message_option.message_type = 'error';
                    current_object.message_option.message = warning_message;
                    return false;
                } else {
                    current_object.message_option.message_type = 'success';
                    current_object.message_option.message = '';
                }
console.log('allen debug current_object.item_map',current_object.item_map,current_object.current_id);
                if (current_object.current_id) {
                    if (current_object.item_map.document_brand[current_object.current_id]) {
                        post_data = Object.assign(current_object.item_map.document_brand[current_object.current_id],post_data);
                    } else {
                        current_object.item_map.document_brand[current_object.current_id] = post_data;
                    }
                    post_data.id = current_object.current_id;
                    post_data.company_id = current_object.current_id;
                } else {
                    let index_counter = 1;
                    while (current_object.item_map.document_brand['new_'+index_counter]) {
                        index_counter++;
                    }
                    // TODO: get company_id
                    post_data.id = 'new_'+index_counter;
                    post_data.company_id = 'new_'+index_counter;
                    current_object.item_map.document_brand['new_'+index_counter] = post_data;
                }


                if ($(current_object.$el.parentNode).hasClass('scrolltop_container')) {
                    let scrolltop_wrapper = $(current_object.$el.parentNode).closest('.scrolltop_wrapper');
                    if (scrolltop_wrapper.length > 0) {
                        $('html, body').scrollTop(scrolltop_wrapper.offset().top);
                    }
                }
// console.log('allen debug update contact submit',current_object.current_trust_party.id,current_object.trust_party_class,current_object.option.item_map,current_object.item_list);
                // this.$emit('update:new_contact',this.cache_data.id);
                current_object.$emit('submit',post_data.id,'document_brand_id');
            },
            cancel: function () {
                let current_object = this;

                // Erase error message if applicable
                current_object.message_option.message_type = '';
                current_object.message_option.message = '';

                if ($(current_object.$el.parentNode).hasClass('scrolltop_container')) {
                    let scrolltop_wrapper = $(current_object.$el.parentNode).closest('.scrolltop_wrapper');
                    if (scrolltop_wrapper.length > 0) {
                        $('html, body').scrollTop(scrolltop_wrapper.offset().top);
                    }
                }
                current_object.$emit('submit','','document_brand_id','cancel');
            }
        },
        watch: {
            current_id: function () {
                let current_object = this;

                current_object.reset_cache_data();

                if (current_object.current_id && $(current_object.$el.parentNode).hasClass('scrolltop_container')) {

                    $('html, body').stop().animate({
                        scrollTop:$(current_object.$el.parentNode).offset().top - 20
                    }, 550,'swing',function () {
                        $('html, body').scrollTop($(current_object.$el.parentNode).offset().top - 20);
                    });
                }

                current_object.message_option.message = '';
                current_object.message_option.message_type = '';
            }
        }
    }
</script>